module.exports = __webpack_public_path__ + "static/media/IMG_0266.9e8249fe.JPG";